import {ShowMoreArticle} from './show-more-article';

const initShowMoreArticle = () => {
  const showMoreArticle = new ShowMoreArticle();
  showMoreArticle.init();
};

export {initShowMoreArticle};
